import React from 'react';

import { Label } from '../label';

import { DayOfWeekButton, days } from './button';
import { PickerWrapper, StyledButtonWrapper } from './styled';

import type { Day, DayOfWeekButtonProps } from './button';

export type ActiveDaysMap = Record<Day, boolean>;

export type DayOfWeekPickerProps = {
  activeDaysMap: ActiveDaysMap;
  onDayButtonClick: DayOfWeekButtonProps['onClick'];
};

export function DayOfWeekPicker({ activeDaysMap, onDayButtonClick }: DayOfWeekPickerProps) {
  return (
    <PickerWrapper>
      <Label required>Days of the week:</Label>
      <StyledButtonWrapper>
        {days.map((day) => (
          <DayOfWeekButton active={activeDaysMap[day]} day={day} key={day} onClick={onDayButtonClick} />
        ))}
      </StyledButtonWrapper>
    </PickerWrapper>
  );
}
